(function () {
  function initICGSwipers(root) {
    const container = root.querySelector('.icg-swiper__container');
    if (!container || container.__icg_inited) return;

    const prevEl = root.querySelector('.icg-swiper__nav-prev');
    const nextEl = root.querySelector('.icg-swiper__nav-next');
    const paginationEl = root.querySelector('.icg-swiper__pagination');

    const blogCarousel = document.querySelector('[data-blog-carousel]');

    let swiperOptions = {
      spaceBetween: 16,
      centeredSlides: false,
      slidesPerView : "auto",
      navigation: { prevEl, nextEl },
      pagination: { el: paginationEl, clickable: true },
    }

    if (blogCarousel) {   
      swiperOptions.spaceBetween = 12;
      swiperOptions.slidesPerView = 1.1;
      swiperOptions.breakpoints = {
        768: {
          spaceBetween: 18,
          slidesPerView: 3,
        }
      }
    }
  
    const swiper = new Swiper(container, swiperOptions);

    container.__icg_inited = swiper;
  }

  function initAll() {
    document.querySelectorAll('.information-card-grid').forEach(initICGSwipers);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target?.matches?.('.information-card-grid')) initICGSwipers(e.target);
  });
})();
